import type { ReactNode } from 'react';

import { Icon } from '@/components/Icon/Icon';
import type { BrokerageSummary } from '@/graphql/brokerages';
import { brokerageName } from '@/lib/brokerages';
import { initialsOf } from '@/lib/lenders';

import styles from './BrokerageList.module.css';

export interface BrokerageListProps {
  brokerages: readonly BrokerageSummary[];
  /** Wraps a row in a link to the brokerage; routing is the caller's. */
  renderLink: (brokerage: BrokerageSummary, children: ReactNode) => ReactNode;
}

/** The brokerages you manage, each row opening the brokerage. */
export function BrokerageList({ brokerages, renderLink }: BrokerageListProps) {
  return (
    <ul aria-label="Brokerages" className={styles.list}>
      {brokerages.map((brokerage) => {
        const name = brokerageName(brokerage);
        const other =
          brokerage.companyName && brokerage.companyName !== name ? brokerage.companyName : null;
        return (
          <li key={brokerage.id}>
            {renderLink(
              brokerage,
              <span className={styles.row}>
                <span aria-hidden="true" className={styles.monogram}>
                  {initialsOf(name)}
                </span>
                <span className={styles.main}>
                  <span className={styles.name}>{name}</span>
                  {other ? <span className={styles.meta}>Emails sent as {other}</span> : null}
                </span>
                <span className={styles.chevron}>
                  <Icon name="caret-right" />
                </span>
              </span>,
            )}
          </li>
        );
      })}
    </ul>
  );
}
